<template>
  <div class="overflow-auto" v-if="computedRows > 0">
    <b-pagination
        v-model="currentPage"
        :total-rows="computedRows"
        :per-page="perPage"
        first-number
        @input="updateQuery"
    />
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      required: true,
    },
    queryName: {
      type: String,
      default: 'page',
    },
  },
  data() {
    return {
      perPage: 1,
      currentPage: 1,
    };
  },
  computed: {
    computedRows() {
      return this.total || 0;
    },
  },
  watch: {
    '$route.query.page': {
      immediate: true,
      handler(newVal) {
        const pageFromQuery = parseInt(newVal) || 1;
        if (this.currentPage !== pageFromQuery) {
          this.currentPage = pageFromQuery;
        }
      }
    }
  },
  methods: {
    updateQuery() {
      const currentQueryPage = parseInt(this.$route.query[this.queryName]) || 1;

      if (currentQueryPage === this.currentPage) return;

      this.$router.push({
        query: {
          ...this.$route.query,
          [this.queryName]: this.currentPage,
        },
      });
    },
  },
};
</script>